import { CounsellingCounsellorEntity, CounsellingEntity, PostEntity } from 'mk2/apps/forum/schemas';
import { Entity, PhotoEntity, UserEntity } from 'mk2/schemas';
import { schema } from 'normalizr';

export enum HomePostType {
    YOUTUBE_MK = 'youtubeMK',
    FROM_INTERNET = 'fromInternet',

    PHOTOBLOG_ALBUM = 'photoblogAlbum',
    PHOTOBLOG_ARTICLE = 'photoblogArticle',
    SHORT_MESSAGE = 'shortMessage',

    COUNSELLING = 'counselling',
    COUNSELLING_TOPIC = 'counsellingTopic',
    COUNSELLING_COMMENT = 'counsellingComment',

    CONTEST = 'contest',

    FORUM_TOPIC = 'forumTopic',
    DISCUSSION = 'discussion',
    FORUM_COMMENT = 'forumComment',

    WIKI_REVIEW_ARTICLE = 'wikiReviewArticle',
    WIKI_ARTICLE = 'wikiArticle',
    WIKI_EXPERIENCE = 'experience',

    STROLLER_USER_REVIEW = 'review',

    DISCUSSION_HINTS = 'discussionHints',
    TOPIC_HINTS = 'topicHints',
}

export interface UtmQuery {
    utm_campaign?: string;
    utm_medium?: string;
    utm_source?: string;
    utm_content?: string;
    mkutm_campaign?: string;
    mkutm_medium?: string;
    mkutm_source?: string;
    mkutm_content?: string;
}

export interface HomePostEntity extends Entity {
    hpid?: string;
    photo: PhotoEntity;
    title: string;
    description: string;
    type: HomePostType;
    isHomepagePost?: boolean;
    publishTime: string;
    url: string;

    objectId?: number;
    entityName?: string;
    likes?: number;
    comments?: number;

    repliedToMessageAuthor?: string;
    repliedToMessageBody?: string;
    repliedToMessageUrl?: string;
    repliedToMessagePhoto?: PhotoEntity;
    parentMessageAuthor?: string;
    parentMessageBody?: string;
    parentMessageUrl?: string;
    parentMessagePhoto?: PhotoEntity;

    topicId?: number;
    topicName?: string;
    topicSlug?: string;

    user?: UserEntity;
    anonymousUserPseudonym?: string;
    counsellor?: CounsellingCounsellorEntity;

    snippetJson?: string;

    starsCount?: number;
    verificationStatus?: number;
    parentWikiArticleId?: number;
    parentWikiArticleTitle?: string;
    parentWikiArticleCategorySlug?: string;
    parentWikiArticleSlug?: string;
    parentWikiArticleScore?: string;
    parentWikiArticleExpCount?: number;
    parentWikiArticlePhoto?: PhotoEntity;
    parentWikiArticle2Title?: string;
    parentWikiArticle2Slug?: string;
    parentWikiArticle3Title?: string;
    parentWikiArticle3Slug?: string;
}

export interface HomeCounsellingEntity extends Entity {
    counselling: CounsellingEntity;
    posts: PostEntity[];
}

export interface HomePhotoblogPostEntity extends Entity {
    photo: PhotoEntity;
    url: string;
}


export const HomePostSchema = new schema.Entity('homePost', {
});
export const HomePhotoblogPostSchema = new schema.Entity('homePhotoblogPost', {
});
export const HomeCounsellingSchema = new schema.Entity('homeCounselling', {
});
